/* eslint-disable complexity */
import settings from 'Cloud/settings';
import { goTo } from 'reactApp/appHelpers/appHelpers';
import { IS_B2B_BIZ_USER, IS_REACT_PROMO_QUOTA_PAGE } from 'reactApp/appHelpers/configHelpers';
import { changeHomeHistory } from 'reactApp/modules/home/home.actions';
import { store as reduxStore } from 'reactApp/store';
import opener from 'reactApp/utils/opener';

import { CloudFile, CloudItem, EStorageType } from './storage.types';

export const getStorage = (storage: string | null) => {
    return {
        isHome: storage === EStorageType.home,
        isPublic: storage === EStorageType.public,
        isSharedAutodelete: storage === EStorageType.sharedAutodelete,
        isSharedLinks: storage === EStorageType.sharedLinks,
        isSharedIncoming: storage === EStorageType.sharedIncoming,
        isTrashBin: storage === EStorageType.trashbin,
        isAttaches: storage === EStorageType.attaches || storage === EStorageType.viewerAttaches,
        isSearch: storage === EStorageType.search,
        isFavorites: storage === EStorageType.favorites,
        isStock: storage === EStorageType.stock,
        isFeed: storage === EStorageType.feed,
        isStart: storage === EStorageType.start,
        isGallery: storage === EStorageType.gallery,
        isRecommend: storage === EStorageType.recommend,
        isDocuments: storage === EStorageType.documents,
        isStory: storage === EStorageType.story,
        isEditor: storage === EStorageType.office || storage === EStorageType.r7 || storage === EStorageType.myoffice,
        // Для них в старом дереве не дергаем загрузку из апи, для них все загрузки делаем в сагах.
        isReactDataList:
            storage === EStorageType.trashbin ||
            storage === EStorageType.attaches ||
            storage === EStorageType.favorites ||
            storage === EStorageType.recommend ||
            storage === EStorageType.gallery ||
            storage === EStorageType.sharedAutodelete ||
            storage === EStorageType.documents ||
            storage === EStorageType.sharedIncoming ||
            storage === EStorageType.sharedLinks,
        isReactPage:
            storage === EStorageType.home ||
            storage === EStorageType.gallery ||
            storage === EStorageType.favorites ||
            storage === EStorageType.documents ||
            storage === EStorageType.sharedAutodelete ||
            storage === EStorageType.start ||
            storage === EStorageType.albums ||
            storage === EStorageType.quotaCleaner ||
            storage === EStorageType.trashbin ||
            storage === EStorageType.feed ||
            storage === EStorageType.recommend ||
            storage === EStorageType.promocodes ||
            storage === EStorageType.subscriptions ||
            storage === EStorageType.sharedIncoming ||
            storage === EStorageType.sharedLinks ||
            storage === EStorageType.attaches,
        IsPublicOrStock: storage === EStorageType.public || storage === EStorageType.stock,
        isAlbums: storage === EStorageType.albums,
        isQuotaCleaner: storage === EStorageType.quotaCleaner,
    };
};

// выпилить navigateStorage когда будет нормальный хелпер
export const changeStorageHistory = ({
    id,
    storage,
    navigateToStorage,
}: {
    id?: string;
    storage?: EStorageType;
    navigateToStorage?: EStorageType;
}) => {
    if (storage === EStorageType.home && id) {
        reduxStore.dispatch(changeHomeHistory({ id }));
        return;
    }

    if (navigateToStorage) {
        opener(`/${navigateToStorage}${id || ''}`, true);
    } else {
        goTo({ id, storage });
    }
};

export const getPageSubtitle = () => {
    if (IS_REACT_PROMO_QUOTA_PAGE) {
        return 'Единое хранилище Почты и Облака';
    }
    return IS_B2B_BIZ_USER ? 'VK WorkDisk' : 'Облако Mail.ru';
};

export const getPageTitleByStorage = (storage, itemTitle): string => {
    const title = itemTitle ? itemTitle : settings?.storages?.[storage]?.title;
    const subTitle = getPageSubtitle();

    return title ? `${title} / ${subTitle}` : subTitle;
};

export const DEFAULT_API_LIMIT = 500;

export const getLoadMoreLimit = (storage: EStorageType): number => {
    if ([EStorageType.home, EStorageType.public, EStorageType.sharedLinks, EStorageType.sharedIncoming].includes(storage)) {
        return DEFAULT_API_LIMIT;
    }

    if (storage === EStorageType.favorites) {
        return 1000;
    }

    if (storage === EStorageType.search) {
        return 10000;
    }

    return 100;
};

export const isCloudFile = (item?: CloudItem | null): item is CloudFile => !!item && !item.isFolder;
